import { onBuildStatusMap } from "../../_CORE/APP/Templates/_UI/Status/_index";

export const STATUS_MAP_PROJECT = onBuildStatusMap({
    active: { label: "Activo", tone: "ok" },
    planning: { label: "Planificación", tone: "accent" },
    on_hold: { label: "En espera", tone: "warn" },
    paused: { label: "Pausado", tone: "warn" },
    blocked: { label: "Bloqueado", tone: "danger" },
    maintenance: { label: "Mantenimiento", tone: "accent" },
    finished: { label: "Terminado", tone: "ok" },
    cancelled: { label: "Cancelado", tone: "neutral" },
    archived: { label: "Archivado", tone: "neutral" },
    other: { label: "Otro", tone: "neutral" },
}, { base: {} });

export const STATUS_MAP_LOGBOOK = onBuildStatusMap({
    open: { label: "Abierta", tone: "warn" },
    in_progress: { label: "En curso", tone: "accent" },
    pending: { label: "Pendiente", tone: "warn" },
    blocked: { label: "Bloqueada", tone: "danger" },
    review: { label: "En revisión", tone: "accent" },
    solved: { label: "Resuelta", tone: "ok" },
    closed: { label: "Cerrada", tone: "neutral" },
    discarded: { label: "Descartada", tone: "neutral" },
    other: { label: "Otro", tone: "neutral" },
}, { base: {} });

export const STATUS_MAP_PRIORITY = onBuildStatusMap({
    none: { label: "Sin prioridad", tone: "neutral" },
    very_low: { label: "Muy baja", tone: "neutral" },
    low: { label: "Baja", tone: "neutral" },
    medium: { label: "Media", tone: "accent" },
    high: { label: "Alta", tone: "warn" },
    urgent: { label: "Urgente", tone: "danger" },
    critical: { label: "Crítica", tone: "danger" },
    other: { label: "Otra", tone: "neutral" },
}, { base: {} });

export const STATUS_MAP_SUBPROJECT = onBuildStatusMap({
    frontend: { label: "Frontend", tone: "accent" },
    backend: { label: "Backend", tone: "ok" },
    fullstack: { label: "Full stack", tone: "accent" },
    api: { label: "API / servicio", tone: "ok" },
    mobile: { label: "Mobile", tone: "warn" },
    desktop: { label: "Desktop", tone: "neutral" },
    database: { label: "Base de datos", tone: "neutral" },
    devops: { label: "DevOps", tone: "accent" },
    infrastructure: { label: "Infraestructura", tone: "warn" },
    microservice: { label: "Microservicio", tone: "ok" },
    library: { label: "Librería / paquete", tone: "neutral" },
    automation: { label: "Automatización", tone: "accent" },
    integration: { label: "Integración", tone: "warn" },
    documentation: { label: "Documentación", tone: "neutral" },
    testing: { label: "Testing / QA", tone: "accent" },
    other: { label: "Otro", tone: "neutral" },
}, { base: {} });

export const STATUS_MAP_ROUTE = onBuildStatusMap({
    local: { label: "Local", tone: "neutral" },
    development: { label: "Desarrollo", tone: "accent" },
    test: { label: "Testing", tone: "neutral" },
    qa: { label: "QA", tone: "accent" },
    stage: { label: "Stage", tone: "warn" },
    staging: { label: "Staging", tone: "warn" },
    preproduction: { label: "Preproducción", tone: "warn" },
    demo: { label: "Demo", tone: "accent" },
    sandbox: { label: "Sandbox", tone: "neutral" },
    production: { label: "Producción", tone: "ok" },
    other: { label: "Otro / personalizado", tone: "neutral" },
}, { base: {} });

export const OPTIONS_PROJECT_STATUS = [
    { value: "ACTIVE", label: "Activo" },
    { value: "PLANNING", label: "Planificación" },
    { value: "ON_HOLD", label: "En espera" },
    { value: "PAUSED", label: "Pausado" },
    { value: "BLOCKED", label: "Bloqueado" },
    { value: "MAINTENANCE", label: "Mantenimiento" },
    { value: "FINISHED", label: "Terminado" },
    { value: "CANCELLED", label: "Cancelado" },
    { value: "ARCHIVED", label: "Archivado" },
    { value: "OTHER", label: "Otro" },
];

export const OPTIONS_LOGBOOK_TYPE = [
    { value: "SPEC", label: "Especificación" },
    { value: "TASK", label: "Tarea" },
    { value: "ISSUE", label: "Problema" },
    { value: "BUG", label: "Bug" },
    { value: "SOLUTION", label: "Solución" },
    { value: "IDEA", label: "Idea" },
    { value: "MEETING", label: "Reunión" },
    { value: "DECISION", label: "Decisión técnica" },
    { value: "RESEARCH", label: "Investigación" },
    { value: "NOTE", label: "Nota" },
    { value: "DEPLOY", label: "Deploy / release" },
    { value: "INCIDENT", label: "Incidente" },
    { value: "DOCUMENTATION", label: "Documentación" },
    { value: "REVIEW", label: "Revisión" },
    { value: "LOG", label: "Registro" },
    { value: "OTHER", label: "Otro" },
];

export const OPTIONS_LOGBOOK_STATUS = [
    { value: "OPEN", label: "Abierta" },
    { value: "IN_PROGRESS", label: "En curso" },
    { value: "PENDING", label: "Pendiente" },
    { value: "BLOCKED", label: "Bloqueada" },
    { value: "REVIEW", label: "En revisión" },
    { value: "SOLVED", label: "Resuelta" },
    { value: "CLOSED", label: "Cerrada" },
    { value: "DISCARDED", label: "Descartada" },
    { value: "OTHER", label: "Otro" },
];

export const OPTIONS_PRIORITY = [
    { value: "NONE", label: "Sin prioridad" },
    { value: "VERY_LOW", label: "Muy baja" },
    { value: "LOW", label: "Baja" },
    { value: "MEDIUM", label: "Media" },
    { value: "HIGH", label: "Alta" },
    { value: "URGENT", label: "Urgente" },
    { value: "CRITICAL", label: "Crítica" },
    { value: "OTHER", label: "Otra" },
];

export const OPTIONS_SUBPROJECT_TYPE = [
    { value: "FRONTEND", label: "Frontend" },
    { value: "BACKEND", label: "Backend" },
    { value: "FULLSTACK", label: "Full stack" },
    { value: "API", label: "API / servicio" },
    { value: "MOBILE", label: "Mobile" },
    { value: "DESKTOP", label: "Desktop" },
    { value: "DATABASE", label: "Base de datos" },
    { value: "DEVOPS", label: "DevOps" },
    { value: "INFRASTRUCTURE", label: "Infraestructura" },
    { value: "MICROSERVICE", label: "Microservicio" },
    { value: "LIBRARY", label: "Librería / paquete" },
    { value: "AUTOMATION", label: "Automatización" },
    { value: "INTEGRATION", label: "Integración" },
    { value: "DOCUMENTATION", label: "Documentación" },
    { value: "TESTING", label: "Testing / QA" },
    { value: "OTHER", label: "Otro" },
];

export const OPTIONS_ROUTE_ENVIRONMENT = [
    { value: "LOCAL", label: "Local" },
    { value: "DEVELOPMENT", label: "Desarrollo" },
    { value: "INTEGRATION", label: "Integración" },
    { value: "CI", label: "CI / automatizado" },
    { value: "TEST", label: "Testing" },
    { value: "QA", label: "QA" },
    { value: "UAT", label: "UAT / aceptación" },
    { value: "REVIEW", label: "Review / PR" },
    { value: "PREVIEW", label: "Preview" },
    { value: "STAGE", label: "Stage" },
    { value: "STAGING", label: "Staging" },
    { value: "CANARY", label: "Canary" },
    { value: "PREPRODUCTION", label: "Preproducción" },
    { value: "DEMO", label: "Demo" },
    { value: "SANDBOX", label: "Sandbox" },
    { value: "TRAINING", label: "Capacitación" },
    { value: "DR", label: "Disaster recovery" },
    { value: "PRODUCTION", label: "Producción" },
    { value: "OTHER", label: "Otro / personalizado" },
];

export const OPTIONS_ENVIRONMENT_CODE = [
    { value: "LOCAL", label: "Local" },
    { value: "DEVELOP", label: "Desarrollo" },
    { value: "INTEGRATION", label: "Integración" },
    { value: "CI", label: "CI / automatizado" },
    { value: "TEST", label: "Testing" },
    { value: "QA", label: "QA" },
    { value: "UAT", label: "UAT / aceptación" },
    { value: "REVIEW", label: "Review / PR" },
    { value: "PREVIEW", label: "Preview" },
    { value: "STAGING", label: "Staging" },
    { value: "CANARY", label: "Canary" },
    { value: "PREPRODUCTION", label: "Preproducción" },
    { value: "DEMO", label: "Demo" },
    { value: "SANDBOX", label: "Sandbox" },
    { value: "TRAINING", label: "Capacitación" },
    { value: "DR", label: "Disaster recovery" },
    { value: "PRODUCTION", label: "Producción" },
    { value: "OTHER", label: "Otro / personalizado" },
];

export const OPTIONS_VAULT_ENVIRONMENT = [
    { value: "", label: "Sin entorno" },
    ...OPTIONS_ENVIRONMENT_CODE,
];

export const OPTIONS_CREDENTIAL_TYPE = [
    { value: "DATABASE", label: "Base de datos" },
    { value: "DATABASE_ADMIN", label: "Administrador de base de datos" },
    { value: "SERVER", label: "Servidor" },
    { value: "VPS", label: "VPS / instancia" },
    { value: "HOSTING", label: "Hosting" },
    { value: "SSH", label: "SSH" },
    { value: "RDP", label: "RDP / Escritorio remoto" },
    { value: "VPN", label: "VPN" },
    { value: "FTP", label: "FTP" },
    { value: "SFTP", label: "SFTP" },
    { value: "API_KEY", label: "API Key" },
    { value: "TOKEN", label: "Token" },
    { value: "OAUTH", label: "OAuth / aplicación" },
    { value: "SSO", label: "SSO / identidad" },
    { value: "EMAIL", label: "Correo" },
    { value: "SMTP", label: "SMTP" },
    { value: "IMAP", label: "IMAP / buzón" },
    { value: "PANEL", label: "Panel" },
    { value: "REPOSITORY", label: "Repositorio" },
    { value: "CI_CD", label: "CI/CD" },
    { value: "CONTAINER_REGISTRY", label: "Registry de contenedores" },
    { value: "KUBERNETES", label: "Kubernetes" },
    { value: "REDIS", label: "Redis / caché" },
    { value: "QUEUE", label: "Cola / broker" },
    { value: "CLOUD", label: "Cloud" },
    { value: "STORAGE", label: "Storage" },
    { value: "SECRET_MANAGER", label: "Gestor de secretos" },
    { value: "MONITORING", label: "Monitoreo" },
    { value: "ANALYTICS", label: "Analytics" },
    { value: "DOMAIN", label: "Dominio" },
    { value: "DNS", label: "DNS" },
    { value: "CDN", label: "CDN" },
    { value: "WEBHOOK", label: "Webhook" },
    { value: "CERTIFICATE", label: "Certificado" },
    { value: "PAYMENT", label: "Pagos / gateway" },
    { value: "OTHER", label: "Otra" },
];

export const CREDENTIAL_FIELDS_ESSENTIAL = ["email", "username", "secret", "passwordHint"];

export const CREDENTIAL_FIELDS_BY_TYPE = {
    DATABASE: ["host", "port", "databaseName", "connectionString", "token"],
    SERVER: ["host", "port"],
    VPS: ["host", "port"],
    HOSTING: ["host", "port"],
    SSH: ["host", "port", "token"],
    FTP: ["host", "port"],
    SFTP: ["host", "port"],
    API_KEY: ["host", "token"],
    TOKEN: ["host", "token"],
    OAUTH: ["host", "token"],
    EMAIL: ["host", "port"],
    PANEL: ["host"],
    REPOSITORY: ["host", "token"],
    CLOUD: ["host", "token"],
    STORAGE: ["host", "token"],
    DOMAIN: ["host"],
    DNS: ["host", "token"],
    CDN: ["host", "token"],
    WEBHOOK: ["host", "token"],
    CERTIFICATE: ["host", "token"],
    PAYMENT: ["host", "token"],
    DATABASE_ADMIN: ["host", "port", "databaseName", "connectionString", "token"],
    RDP: ["host", "port"],
    VPN: ["host", "port", "token"],
    SSO: ["host", "token"],
    SMTP: ["host", "port"],
    IMAP: ["host", "port"],
    CI_CD: ["host", "token"],
    CONTAINER_REGISTRY: ["host", "token"],
    KUBERNETES: ["host", "token"],
    REDIS: ["host", "port", "connectionString"],
    QUEUE: ["host", "port", "connectionString"],
    SECRET_MANAGER: ["host", "token"],
    MONITORING: ["host", "token"],
    ANALYTICS: ["host", "token"],
    OTHER: ["host", "port", "token", "databaseName", "connectionString"],
};

export const CREDENTIAL_FIELD_LABELS = {
    email: "Correo",
    host: "Host o dirección",
    port: "Puerto",
    username: "Usuario",
    secret: "Contraseña",
    passwordHint: "Pista / palabra secreta",
    token: "Token / API key / secreto",
    databaseName: "Base de datos",
    connectionString: "Cadena de conexión",
};

export const onCredentialFields = (type) => [
    ...CREDENTIAL_FIELDS_ESSENTIAL,
    ...(CREDENTIAL_FIELDS_BY_TYPE[type] ?? CREDENTIAL_FIELDS_BY_TYPE.OTHER),
];

export const onHasCredentialField = (type, field) => onCredentialFields(type).includes(field);

export const OPTIONS_LINK_CATEGORY = [
    { value: "REPOSITORY", label: "Repositorio" },
    { value: "DOCS", label: "Documentación" },
    { value: "DESIGN", label: "Diseño" },
    { value: "PANEL", label: "Panel" },
    { value: "DEPLOY", label: "Deploy" },
    { value: "DATABASE", label: "Base de datos" },
    { value: "API", label: "API" },
    { value: "MONITORING", label: "Monitoreo" },
    { value: "ANALYTICS", label: "Analytics" },
    { value: "CLOUD", label: "Cloud" },
    { value: "HOSTING", label: "Hosting" },
    { value: "DOMAIN", label: "Dominio / DNS" },
    { value: "SECURITY", label: "Seguridad" },
    { value: "TICKET", label: "Ticket / issue" },
    { value: "COMMUNICATION", label: "Comunicación" },
    { value: "OTHER", label: "Otro" },
];

export const OPTIONS_SNIPPET_TARGET = [
    { value: "FRONTEND", label: "Frontend" },
    { value: "BACKEND", label: "Backend" },
    { value: "FULLSTACK", label: "Full stack" },
    { value: "DATABASE", label: "Base de datos" },
    { value: "DEVOPS", label: "DevOps" },
    { value: "INFRASTRUCTURE", label: "Infraestructura" },
    { value: "MOBILE", label: "Mobile" },
    { value: "DESKTOP", label: "Desktop" },
    { value: "CLOUD", label: "Cloud" },
    { value: "AUTOMATION", label: "Automatización" },
    { value: "TESTING", label: "Testing / QA" },
    { value: "GENERAL", label: "General" },
    { value: "OTHER", label: "Otro" },
];

export const OPTIONS_SNIPPET_KIND = [
    { value: "SCRIPT", label: "Script" },
    { value: "COMMAND", label: "Comando" },
    { value: "QUERY", label: "Consulta" },
    { value: "CONFIG", label: "Configuración" },
    { value: "SNIPPET", label: "Fragmento" },
    { value: "TEMPLATE", label: "Plantilla" },
    { value: "FUNCTION", label: "Función" },
    { value: "CLASS", label: "Clase" },
    { value: "COMPONENT", label: "Componente" },
    { value: "HOOK", label: "Hook" },
    { value: "MIGRATION", label: "Migración" },
    { value: "REGEX", label: "Expresión regular" },
    { value: "DOCKER", label: "Docker / compose" },
    { value: "CI_CD", label: "CI / CD" },
    { value: "OTHER", label: "Otro" },
];

export const PALETTE_HEX = [
    "#919191", "#646464", "#989898", "#aaaaaa",
    "#a6a6a6", "#9a9a9a", "#9a9a9a", "#888888",
    "#797979", "#666666", "#787878", "#e9e9e9",
];

export const OPTIONS_VAULT_KIND = [
    { value: "SERVICE", label: "Servicio" },
    { value: "HOSTING", label: "Hosting" },
    { value: "CLOUD", label: "Nube" },
    { value: "SERVER", label: "Servidor / VPS" },
    { value: "DATABASE", label: "Base de datos" },
    { value: "INFRASTRUCTURE", label: "Infraestructura" },
    { value: "STORE", label: "Tienda o consola" },
    { value: "BANK", label: "Banco o pagos" },
    { value: "SOCIAL", label: "Redes sociales" },
    { value: "REPOSITORY", label: "Código / repositorios" },
    { value: "DOMAIN", label: "Dominios / DNS" },
    { value: "EMAIL", label: "Correo" },
    { value: "SECURITY", label: "Seguridad" },
    { value: "NETWORK", label: "Red / conectividad" },
    { value: "INTERNAL", label: "Interno" },
    { value: "OTHER", label: "Otro" },
];

export const OPTIONS_VAULT_ENTRY_TYPE = [
    { value: "SERVER", label: "Servidor" },
    { value: "DATABASE", label: "Base de datos" },
    { value: "PANEL", label: "Panel" },
    { value: "API_KEY", label: "API Key" },
    { value: "TOKEN", label: "Token" },
    { value: "OAUTH", label: "OAuth / aplicación" },
    { value: "EMAIL", label: "Correo" },
    { value: "FTP", label: "FTP" },
    { value: "SFTP", label: "SFTP" },
    { value: "SSH", label: "SSH" },
    { value: "REPOSITORY", label: "Repositorio" },
    { value: "LICENSE", label: "Licencia" },
    { value: "CERTIFICATE", label: "Certificado" },
    { value: "DOMAIN", label: "Dominio / DNS" },
    { value: "CLOUD", label: "Cloud" },
    { value: "STORAGE", label: "Storage" },
    { value: "WEBHOOK", label: "Webhook" },
    { value: "OTHER", label: "Otro" },
];

export const OPTIONS_PERSONAL_VAULT_ENTRY_TYPE = [
    { value: "ACCOUNT", label: "Cuenta / servicio" },
    { value: "EMAIL", label: "Correo" },
    { value: "BANK", label: "Banco" },
    { value: "PAYMENT", label: "Pagos / billetera" },
    { value: "SOCIAL", label: "Red social" },
    { value: "SUBSCRIPTION", label: "Suscripción" },
    { value: "STREAMING", label: "Streaming" },
    { value: "SHOPPING", label: "Compras / e-commerce" },
    { value: "EDUCATION", label: "Educación / curso" },
    { value: "PROFESSIONAL", label: "Profesional / trabajo" },
    { value: "GAMING", label: "Gaming" },
    { value: "TRAVEL", label: "Viajes" },
    { value: "GOVERNMENT", label: "Gobierno / trámite" },
    { value: "INSURANCE", label: "Seguro" },
    { value: "CLOUD", label: "Nube" },
    { value: "HOSTING", label: "Hosting" },
    { value: "SERVER", label: "Servidor" },
    { value: "DATABASE", label: "Base de datos" },
    { value: "PANEL", label: "Panel" },
    { value: "API_KEY", label: "API Key" },
    { value: "TOKEN", label: "Token" },
    { value: "OAUTH", label: "OAuth / aplicación" },
    { value: "REPOSITORY", label: "Repositorio" },
    { value: "LICENSE", label: "Licencia" },
    { value: "WIFI", label: "Wi-Fi / red" },
    { value: "DEVICE", label: "Dispositivo" },
    { value: "IDENTITY", label: "Identidad / documento" },
    { value: "DOMAIN", label: "Dominio / DNS" },
    { value: "CERTIFICATE", label: "Certificado" },
    { value: "FTP", label: "FTP" },
    { value: "SFTP", label: "SFTP" },
    { value: "SSH", label: "SSH" },
    { value: "OTHER", label: "Otro" },
];

export const OPTIONS_PERSONAL_VAULT_AUTH_MODE = [
    { value: "NONE", label: "Sin segundo factor" },
    { value: "GOOGLE_AUTHENTICATOR", label: "Google Authenticator" },
    { value: "MICROSOFT_AUTHENTICATOR", label: "Microsoft Authenticator" },
    { value: "AUTHY", label: "Authy" },
    { value: "ONEPASSWORD", label: "1Password" },
    { value: "BITWARDEN", label: "Bitwarden Authenticator" },
    { value: "PROTON_PASS", label: "Proton Pass" },
    { value: "DUO_MOBILE", label: "Duo Mobile" },
    { value: "OKTA_VERIFY", label: "Okta Verify" },
    { value: "AEGIS", label: "Aegis Authenticator" },
    { value: "APPLE_PASSWORDS", label: "Apple Passwords / Códigos" },
    { value: "TOTP_OTHER", label: "Otro autenticador TOTP" },
    { value: "PUSH", label: "Notificación push" },
    { value: "SMS", label: "SMS" },
    { value: "WHATSAPP", label: "WhatsApp" },
    { value: "VOICE_CALL", label: "Llamada telefónica" },
    { value: "EMAIL", label: "Código por email" },
    { value: "SECURITY_KEY", label: "Llave de seguridad física" },
    { value: "YUBIKEY_OTP", label: "YubiKey OTP" },
    { value: "HARDWARE_TOKEN", label: "Token físico" },
    { value: "PASSKEY", label: "Passkey" },
    { value: "BACKUP_CODES", label: "Códigos de recuperación" },
    { value: "OTHER", label: "Otro método" },
];

export const OPTIONS_PERSONAL_VAULT_FILE_PURPOSE = [
    { value: "GENERAL", label: "Documento general" },
    { value: "RECOVERY_KIT", label: "Kit de recuperación" },
    { value: "TWO_FACTOR", label: "Respaldo de 2 pasos" },
    { value: "CERTIFICATE", label: "Certificado" },
    { value: "KEY_FILE", label: "Archivo de clave" },
    { value: "LICENSE", label: "Licencia" },
    { value: "IDENTITY_DOCUMENT", label: "Documento de identidad" },
    { value: "CONTRACT", label: "Contrato" },
    { value: "INVOICE", label: "Factura / comprobante" },
    { value: "SECURITY_EXPORT", label: "Exportación de seguridad" },
    { value: "CONFIGURATION", label: "Configuración" },
    { value: "BACKUP", label: "Backup" },
    { value: "OTHER", label: "Otro" },
];

export const OPTIONS_CHANGE_ACTION = [
    { value: "CREATED", label: "Creado" },
    { value: "MODIFIED", label: "Modificado" },
    { value: "UPDATED", label: "Actualizado" },
    { value: "RENAMED", label: "Renombrado" },
    { value: "MOVED", label: "Movido" },
    { value: "COPIED", label: "Copiado" },
    { value: "MERGED", label: "Fusionado" },
    { value: "REFACTORED", label: "Refactorizado" },
    { value: "FIXED", label: "Corregido" },
    { value: "CONFIGURED", label: "Configurado" },
    { value: "MIGRATED", label: "Migrado" },
    { value: "RESTORED", label: "Restaurado" },
    { value: "DEPLOYED", label: "Desplegado" },
    { value: "UPGRADED", label: "Actualizado de versión" },
    { value: "DOWNGRADED", label: "Bajado de versión" },
    { value: "OPTIMIZED", label: "Optimizado" },
    { value: "SECURED", label: "Asegurado / hardening" },
    { value: "TESTED", label: "Testeado" },
    { value: "DOCUMENTED", label: "Documentado" },
    { value: "REMOVED", label: "Quitado" },
    { value: "DELETED", label: "Eliminado" },
    { value: "OTHER", label: "Otro" },
];

export const STATUS_MAP_CHANGE_ACTION = onBuildStatusMap({
    created: { label: "Creado", tone: "ok" },
    modified: { label: "Modificado", tone: "accent" },
    updated: { label: "Actualizado", tone: "accent" },
    renamed: { label: "Renombrado", tone: "warn" },
    moved: { label: "Movido", tone: "neutral" },
    copied: { label: "Copiado", tone: "neutral" },
    merged: { label: "Fusionado", tone: "accent" },
    refactored: { label: "Refactorizado", tone: "accent" },
    fixed: { label: "Corregido", tone: "ok" },
    configured: { label: "Configurado", tone: "accent" },
    migrated: { label: "Migrado", tone: "warn" },
    restored: { label: "Restaurado", tone: "ok" },
    deployed: { label: "Desplegado", tone: "ok" },
    upgraded: { label: "Actualizado de versión", tone: "accent" },
    downgraded: { label: "Bajado de versión", tone: "warn" },
    optimized: { label: "Optimizado", tone: "ok" },
    secured: { label: "Asegurado / hardening", tone: "ok" },
    tested: { label: "Testeado", tone: "accent" },
    documented: { label: "Documentado", tone: "neutral" },
    removed: { label: "Quitado", tone: "danger" },
    deleted: { label: "Eliminado", tone: "danger" },
    other: { label: "Otro", tone: "neutral" },
}, { base: {} });

export const OPTIONS_DRAFT_ORIGIN = [
    { value: "MEETING", label: "Reunión" },
    { value: "CALL", label: "Llamada" },
    { value: "IDEA", label: "Idea suelta" },
    { value: "RESEARCH", label: "Investigación" },
    { value: "EMAIL", label: "Correo" },
    { value: "CHAT", label: "Chat / mensajería" },
    { value: "TICKET", label: "Ticket / issue" },
    { value: "DOCUMENTATION", label: "Documentación" },
    { value: "CLIENT_FEEDBACK", label: "Feedback de cliente" },
    { value: "CODE_REVIEW", label: "Code review" },
    { value: "INCIDENT", label: "Incidente" },
    { value: "PERSONAL_NOTE", label: "Nota personal" },
    { value: "IMPORTED", label: "Importado" },
    { value: "OTHER", label: "Otro" },
];

export const STATUS_MAP_DRAFT_ORIGIN = onBuildStatusMap({
    meeting: { label: "Reunión", tone: "accent" },
    call: { label: "Llamada", tone: "warn" },
    idea: { label: "Idea suelta", tone: "ok" },
    research: { label: "Investigación", tone: "neutral" },
    email: { label: "Correo", tone: "accent" },
    chat: { label: "Chat / mensajería", tone: "accent" },
    ticket: { label: "Ticket / issue", tone: "warn" },
    documentation: { label: "Documentación", tone: "neutral" },
    client_feedback: { label: "Feedback de cliente", tone: "warn" },
    code_review: { label: "Code review", tone: "accent" },
    incident: { label: "Incidente", tone: "danger" },
    personal_note: { label: "Nota personal", tone: "neutral" },
    imported: { label: "Importado", tone: "neutral" },
    other: { label: "Otro", tone: "neutral" },
}, { base: {} });

export const OPTIONS_CODE_LANGUAGE = [
    { value: "text", label: "Texto plano" },
    { value: "bash", label: "Bash / Shell" },
    { value: "powershell", label: "PowerShell" },
    { value: "batch", label: "Batch / CMD" },
    { value: "javascript", label: "JavaScript" },
    { value: "typescript", label: "TypeScript" },
    { value: "jsx", label: "JSX / React" },
    { value: "tsx", label: "TSX / React" },
    { value: "node", label: "Node.js" },
    { value: "ruby", label: "Ruby" },
    { value: "php", label: "PHP" },
    { value: "python", label: "Python" },
    { value: "java", label: "Java" },
    { value: "csharp", label: "C#" },
    { value: "c", label: "C" },
    { value: "cpp", label: "C++" },
    { value: "go", label: "Go" },
    { value: "rust", label: "Rust" },
    { value: "kotlin", label: "Kotlin" },
    { value: "swift", label: "Swift" },
    { value: "dart", label: "Dart" },
    { value: "zsh", label: "Zsh" },
    { value: "fish", label: "Fish" },
    { value: "lua", label: "Lua" },
    { value: "perl", label: "Perl" },
    { value: "r", label: "R" },
    { value: "scala", label: "Scala" },
    { value: "elixir", label: "Elixir" },
    { value: "erlang", label: "Erlang" },
    { value: "groovy", label: "Groovy" },
    { value: "vb", label: "Visual Basic" },
    { value: "sql", label: "SQL" },
    { value: "mysql", label: "MySQL" },
    { value: "postgresql", label: "PostgreSQL" },
    { value: "plsql", label: "PL/SQL" },
    { value: "graphql", label: "GraphQL" },
    { value: "json", label: "JSON" },
    { value: "yaml", label: "YAML" },
    { value: "toml", label: "TOML" },
    { value: "xml", label: "XML" },
    { value: "html", label: "HTML" },
    { value: "css", label: "CSS" },
    { value: "scss", label: "SCSS / Sass" },
    { value: "markdown", label: "Markdown" },
    { value: "dockerfile", label: "Dockerfile" },
    { value: "nginx", label: "Nginx" },
    { value: "apache", label: "Apache" },
    { value: "ini", label: "INI / config" },
    { value: "env", label: ".env" },
    { value: "prisma", label: "Prisma" },
    { value: "hcl", label: "HCL / Terraform" },
    { value: "docker-compose", label: "Docker Compose" },
    { value: "makefile", label: "Makefile" },
    { value: "nginx-conf", label: "Nginx config" },
    { value: "other", label: "Otro / personalizado" },
];

export const onFindOptionLabel = (options = [], value = null) => (
    options.find((option) => option.value === value)?.label ?? value ?? ""
);
